export default function CommandesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('commandes');
}

CommandesConfiguration.$inject = ['$translatePartialLoaderProvider'];
